import { useMutation, useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerInvites } from "@/lib/query/core/invalidation";

type RevokeStoreInviteInput = {
  storeSlug: string;
  inviteId: string;
};

export function useRevokeStoreInviteMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ inviteId }: RevokeStoreInviteInput) =>
      apiJsonClient<void>(endpoints.seller.inviteById(inviteId), {
        method: "DELETE",
      }),
    onSuccess: async (_data, variables) => {
      await invalidateSellerInvites(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
